// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"fad0463f","744":"fad0463f","2855":"fad0463f","4105":"1f08cf17"}[chunkId] + ".chunk.css";
};